import { BrowserRouter as Router, Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { doRegistration } from './components/customCtrlRegistrations';
import { lazy, Suspense, useEffect, useMemo } from 'react';
import { createEntities } from './entities/entityRegistrations';
import { InnerRootContext } from './components/RootContext';
import useAppState from './common/hooks/appStateHook';
import { useAppStateContext } from './common/utils/AppStateContext';
import { InternalNavBar, SITEMAP } from './components/InternalNavBar';
import PublicNavBar from './components/PublicNavBar';
import { Spinner } from 'react-bootstrap';
import { ForgottenPassword } from './components/ForgottenPassword';
import ResetPassword from './common/components/ResetPassword';
import LoginScreen from './screens/loginScreen';
import ExpressionOfInterestPublicScreen from './screens/expressionOfInterestPublicScreen';

const DefaultPath = () => {
    const { token } = useAppState();

    const hash = window.location.hash; // includes the `#!...` part

    // Match the old-style hashbang path and query
    const hashMatch = hash.match(/^#!\/(publicform|publicgroup)\/([^?#]+)(\?[^#]*)?/);

    if (hashMatch) {
        const [, type, code, queryParams = ''] = hashMatch;
        return <Navigate to={`/${type}/${code}${queryParams}`}></Navigate>;
    }

    if (token) {
        return <Navigate to="/home" replace></Navigate>
    }
    return <Navigate to="/login" replace></Navigate>
}

export const RequireAuth = () => {
    const { token } = useAppStateContext();
    if (!token) {
        return <Navigate to="/login" replace></Navigate>;
    }
    return <InternalNavBar>
        <Outlet></Outlet>
    </InternalNavBar>;
}

function App() {
    useEffect(() => {
      doRegistration();
      createEntities();
    }, []);

    const routes = useMemo(() => Array.from(SITEMAP.values()).flat().map(r => ({ ...r, Component: lazy(r.loader) })), []);
    
    return (
        <Suspense fallback={<Spinner></Spinner>}>
        <Router basename={process.env.NODE_ENV === 'production' ? '/ora' : '/'}>
            <Routes>
                <Route element={<InnerRootContext><Outlet></Outlet></InnerRootContext>}>
                    <Route path="/" element={<DefaultPath></DefaultPath>}></Route>
                    <Route element={<PublicNavBar></PublicNavBar>}>
                        <Route path="/login" element={<LoginScreen></LoginScreen>}></Route>
                        <Route path="/forgottenPassword" element={<ForgottenPassword></ForgottenPassword>}></Route>
                        <Route path="/resetPassword" element={<ResetPassword></ResetPassword>}></Route>
                        <Route path="/public_eoi" element={<ExpressionOfInterestPublicScreen></ExpressionOfInterestPublicScreen>}></Route>
                    </Route>
                    <Route element={<RequireAuth></RequireAuth>}>
                        {routes.map(r => {
                            return <Route key={r.uuid} path={r.path} element={<r.Component {...(r.params || {})}></r.Component>}></Route>
                        })}
                    </Route>
                </Route>
            </Routes>
        </Router>
        </Suspense>
    );
}

export default App;